import { render } from "./EmailSent.vue?vue&type=template&id=54dcedad&scoped=true"
import script from "./EmailSent.vue?vue&type=script&lang=js"
export * from "./EmailSent.vue?vue&type=script&lang=js"

import "./EmailSent.vue?vue&type=style&index=0&id=54dcedad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54dcedad"]])

export default __exports__